import { AxiosError } from 'axios';
import { restErrorsToForm } from '@unitedtraders/microfrontend-common';
import { createValidator, required, latinLettersOnly } from '@unitedtraders/validators';
import { validCardNumber } from '../../../utils/validators';
import { Instrument } from '../../../hooks/mapInstruments';
import { useWithdrawService } from '../../../hooks/useWithdrawService';
import { useAmountValidators } from '../../../components/AmountInput/hooks';
import { FormValues } from '.';

export const useFormProps = (instrument: Instrument) => {
  const withdrawService = useWithdrawService();
  const amountValidators = useAmountValidators(instrument);

  const validate = createValidator<FormValues>({
    amount: amountValidators,
    cardNumber: [required(), validCardNumber()],
    cardHolderName: [required(), latinLettersOnly('validator:latins letters only')],
  });

  return {
    validate,
    onSubmit: async (values: FormValues) => {
      try {
        if(!instrument.id) {
          throw new Error('instrument id is not defined');
        }
        await withdrawService.prepareCardWithdraw(
          { value: values.amount, currency: instrument.currency },
          values.cardNumber.replace(/[^\d]/g, ''),
          values.cardHolderName.toUpperCase(),
          { instrumentId: instrument.id, isTargetAmountUsed: false }
        );
        return;
      } catch (e: AxiosError | any) {
        return restErrorsToForm(e.response?.data || e);
      }
    },
  };
};
